import { render, staticRenderFns } from "./WidgetsReportIncomeReceipt.vue?vue&type=template&id=01a24bc8&scoped=true"
import script from "./WidgetsReportIncomeReceipt.vue?vue&type=script&lang=js"
export * from "./WidgetsReportIncomeReceipt.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportIncomeReceipt.vue?vue&type=style&index=0&id=01a24bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a24bc8",
  null
  
)

export default component.exports